import { BottomSheet, Text, type UseModalState } from "@clipboard-health/ui-components";
import { zodResolver } from "@hookform/resolvers/zod";
import { DialogContent, Stack, TextField } from "@mui/material";
import { LoadingButton } from "@src/appV2/redesign/components/LoadingButton";
import { useForm } from "react-hook-form";
import { z } from "zod";

const createChannelSchema = z.object({
  name: z.string().min(1, "Name is required"),
  description: z.string().min(1, "Description is required"),
});

type CreateChannelFormData = z.infer<typeof createChannelSchema>;

interface CreateChannelBottomSheetProps {
  modalState: UseModalState;
  onSubmit: (data: CreateChannelFormData) => Promise<void>;
}

export function CreateChannelBottomSheet({ modalState, onSubmit }: CreateChannelBottomSheetProps) {
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm<CreateChannelFormData>({
    resolver: zodResolver(createChannelSchema),
  });

  return (
    <BottomSheet modalState={modalState}>
      <DialogContent>
        <Stack spacing={4}>
          <Text bold variant="h6">
            Create New Chatroom
          </Text>
          <form onSubmit={handleSubmit(onSubmit)}>
            <Stack spacing={6}>
              <TextField
                {...register("name")}
                fullWidth
                label="Name"
                error={Boolean(errors.name)}
                helperText={errors.name?.message}
              />
              <TextField
                {...register("description")}
                fullWidth
                multiline
                label="Description"
                error={Boolean(errors.description)}
                helperText={errors.description?.message}
                rows={2}
              />
              <LoadingButton fullWidth type="submit" variant="contained" isLoading={isSubmitting}>
                Create Chatroom
              </LoadingButton>
            </Stack>
          </form>
        </Stack>
      </DialogContent>
    </BottomSheet>
  );
}
